(() => {
  if (customElements.get('big-product-confidence')) return;
  customElements.define('big-product-confidence', class extends HTMLElement {
    connectedCallback() {
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.observer = new MutationObserver(this.queue);
      const main = document.getElementById('MainContent');
      if (main) this.observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['id', 'data-id', 'data-product-id'] });
      this.sync();
    }
    sync() {
      const link = this.querySelector('[data-blj-review-link]');
      const widgets = document.querySelectorAll('#judgeme_product_reviews');
      const widget = widgets.length === 1 && (widgets[0].dataset.id === this.dataset.productId || widgets[0].dataset.productId === this.dataset.productId) ? widgets[0] : null;
      if (link) { link.hidden = !widget; if (widget) link.setAttribute('href', '#' + widget.id); }
    }
    disconnectedCallback() { this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame = 0; }
  });
})();
